import ResumeEducationInformation from "./ResumeEducationInformation";

export default ResumeEducationInformation;
